// Set version number and date in the environment.store.ts file

export const environment = {
  production: true,
  baseUrl: 'https://program-api-test-b3dygsa2h2fzg4dx.westus-01.azurewebsites.net',
  context: 'test',
  maxEffectiveDateDays: 120,
};
